import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";

function TiposModal({
  isOpen,
  setIsOpen,
  tipos,
  togEditarTipoModal,
  deletartipo,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Chave",
        accessor: "chave",
        isSorted: true,
      },
      {
        Header: "Valor",
        accessor: "valor",
        isSorted: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        largura: "150px",
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`editar-${row.original.uid}`}
                onClick={() => {
                  togEditarTipoModal(row.original);
                }}
                color="success"
                icon="mdi mdi-file-edit"
              >
                Editar
              </DropdownButton>
              <DropdownButton
                key={`editar-${row.original.uid}`}
                onClick={() => {
                  deletartipo(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-trash-can"
              >
                Deletar
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [deletartipo, togEditarTipoModal]
  );

  return (
    <CommonModal
      title={"Tipos"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="xl"
      buttons={<></>}
    >
      <div className="row">
        <div className="col" style={{ padding: "0px 28px" }}>
          <CommonDataTable colunas={colunas} linhas={tipos} />
        </div>
      </div>
    </CommonModal>
  );
}

TiposModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  tipos: PropTypes.array.isRequired,
  togEditarTipoModal: PropTypes.func.isRequired,
  deletartipo: PropTypes.func.isRequired,
  row: PropTypes.array,
};

export default TiposModal;
